module.exports = __webpack_public_path__ + "007ab37daa4e8af0769c51496901fbe0.otf";